import {Button, DialogActions, DialogContent} from '@material-ui/core';
import ClaimRouteConstants from 'Agent/Claims/ClaimRouteConstants';
import { ANALYTICS_EVENT_ACTION } from 'Core/components/Analytics/AnalyticsEventConstants';
import React from 'react';
import {useHistory} from 'react-router';
import Modal from 'Shared/components/Modal';
import { DataSource } from 'Shared/utilities/DataSourceUtility';
import { useSelector, useDispatch } from 'react-redux';
import {ReducerState} from 'rootReducer';
import { changeAnalyticsState } from 'Core/ducks/analytics';

export type ClaimsConfirmationModalProps = {
  onClose: () => void;
  policyNumber: string;
  eisFlag: boolean;
};

const ClaimsConfirmationModal = (props: ClaimsConfirmationModalProps) => {
  const history = useHistory();
  const {analytics} = useSelector((state: ReducerState) => state.analytics);
  const dispatch = useDispatch();

  return (
    <Modal title="View Claims" open onClose={props.onClose}>
      <div className="card__dialog">
        <DialogContent>
          By clicking <strong>"I Agree"</strong>, I represent and warrant that I have read, understand and agree to
          abide by the terms of the Business Associate Addendum. I am accessing this claim information in my capacity as
          a Business Associate, and I will view only the minimum amount of Protected Health Information reasonably
          necessary to perform my duties.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatch(changeAnalyticsState({page: analytics.page, ctaResponse: {eventAction:ANALYTICS_EVENT_ACTION.POLICY_VIEW_DETAILS_VIEW_CLAIMS_IAGREE}}))
              history.push(ClaimRouteConstants.CLAIMS(props.policyNumber, (props.eisFlag? String(DataSource.EIS) : String(DataSource.LEGACY))));
              props.onClose();
            }}
            color="primary"
          >
            I Agree
          </Button>
          <Button onClick={props.onClose}>Cancel</Button>
        </DialogActions>
      </div>
    </Modal>
  );
};

export default ClaimsConfirmationModal;
